<i18n
  src="@/locales/views/agro_exporter/finances/container_outcomes/assign_provider.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>
<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    :name="routeName('show_container')"
    :params="{
      agro_exporter_id: agro_exporter_id,
      agro_exporter_process_id: agro_exporter_process_id,
      container_id: container_id
    }"
  />

  <bread-crumbs :labels="[module_name, agro_exporter_process.name]" />

  <template v-if="load_general_data">
    <div class="mt-8">
      <container-info :agro_exporter_id="agro_exporter_id" :container="container" />
    </div>

    <alert-danger class="mt-6" :errors_data="std_err" />

    <div class="mt-8">
      <div class="panel">
        <div class="panel-header">
          <h3 class="panel-header-title">
            {{ $t("labels.title") }}
          </h3>
        </div>

        <div class="panel-body">
          <div class="space-y-8 divide-y divide-gray-200">
            <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-6">
                <label :class="['label-form', isInvalidLabel('invoice_code')]">
                  {{ $t("model.container.provider") }}
                </label>
                <div class="mt-1">
                  <select-form
                    v-if="producers_organizations.length > 1"
                    :options="producers_organizations"
                    v-model="providers"
                    :multiple="true"
                    label="label"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="panel-footer">
          <div class="panel-footer-actions">
            <white-button
              @click.prevent="goToShowContainer()"
              :label="$t('labels.cancel_button')"
            />
            <span class="space-actions"></span>
            <success-button
              v-if="!proc_save_button"
              @click.prevent="submit()"
              :label="$t('labels.save_button')"
            />
            <success-button-processing
              v-else
              :label="$t('labels.save_button')"
            />
          </div>
        </div>
      </div>
    </div>
  </template>
  <loading-message v-else />
</template>

<script>
import Requester from "@/views/agro_exporter/requesters/finances/container_outcomes/manage_container.js";
import ContainerInfo from "@/components/views/agro_exporter/finances/container_outcomes/ContainerInfo.vue";

export default {
  name: "AeFinancesContainerOutcomesAssignProvider",
  components: { ContainerInfo },
  props: ["agro_exporter_process_id", "agro_exporter_id", "container_id"],
  data() {
    return {
      load_general_data: false,
      proc_save_button: false,
      agro_exporter_process: {},
      container: {},
      producers_organizations: [],
      provider_producer_id: null,
      provider_organization_id: null,
      providers: []
    };
  },
  methods: {
    fetchData: async function () {
      await this.fetchAgroExporterProcess();
      await this.fetchContainer();
      await this.fetchProducersOrganizations();
      this.load_general_data = true;
    },
    fetchAgroExporterProcess: async function () {
      let response = await Requester.fetchAgroExporterProcess(
        this.agro_exporter_id,
        this.agro_exporter_process_id
      );
      this.agro_exporter_process = response.data;
    },
    fetchContainer: async function () {
      let response = await Requester.fetchContainer(
        this.agro_exporter_id,
        this.container_id
      );
      this.container = response.data;
    },
    fetchProducersOrganizations: async function () {
      let response = await Requester.fetchProducersOrganizations(
        this.agro_exporter_id,
        this.agro_exporter_process_id
      );

      this.producers_organizations = response.data;
      this.setProviders();
    },
    setProviders() {
      this.container.container_providers.forEach(cp => {
        let prov = this.producers_organizations.find(
          po =>
            po.producer_id == cp.provider_producer_id &&
            po.organization_id == cp.provider_organization_id
        );
        if (prov) this.providers.push(prov.id);
      });
    },
    submit: async function () {
      this.proc_save_button = true;
      try {
        let response = await Requester.update(
          this.agro_exporter_id,
          this.container_id,
          { container_providers: this.container_providers }
        );
        this.registerSuccessNotification({
          title: response.data.success_message
        });
        this.goToShowContainer();
      } catch (error) {
        if (error.response.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields
          });
        }
      }
      this.proc_save_button = false;
    },
    goToShowContainer: function () {
      this.$router.push({
        name: this.routeName("show_container"),
        params: {
          agro_exporter_id: this.agro_exporter_id,
          agro_exporter_process_id: this.agro_exporter_process_id,
          container_id: this.container_id
        }
      });
    },
    goToShowExportInvoice: function (org_invoice_id) {
      this.$router.push({
        name: this.routeName("show_org_invoice"),
        params: {
          agro_exporter_id: this.agro_exporter_id,
          agro_exporter_process_id: this.agro_exporter_process_id,
          container_id: this.container_id,
          org_invoice_id: org_invoice_id
        }
      });
    }
  },
  computed: {
    container_providers: function () {
      return this.providers.map(id => {
        let prod_org = this.producers_organizations.find(
          option => option.id == id
        );

        let container_provider = {};
        if (prod_org.producer_id)
          container_provider["provider_producer_id"] = prod_org.producer_id;
        if (prod_org.organization_id)
          container_provider["provider_organization_id"] =
            prod_org.organization_id;

        return container_provider;
      });
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id
        }
      }).then(() => {
        this.fetchData();
      })
    );
  }
};
</script>
